import { cn } from '../../lib/utils';

export default function BrandMark({ compact = false, inverse = false, className }) {
  return (
    <div className={cn('flex items-center gap-3', className)} aria-label="Salirà!">
      <img src="https://next.giovanidem.eu/logo.png" alt="Salirà!" className={cn('h-12 w-12', inverse && 'invert')} />
      {!compact && (
        <div className="min-w-0">
          <div className={cn('truncate text-[15px] font-bold leading-none tracking-[-0.01em]', inverse ? 'text-md-on-secondary' : 'text-md-on-surface')}>Salirà!</div>
        </div>
      )}
    </div>
  );
}
